import Vue from 'vue'
import { MUTATIONS } from '~/constants'
import { defaultRequestState } from '~/helpers/store'

const updateState = (state, hash, newValues) => {
  // Create the base request object
  if (!state.data[hash]) {
    Vue.set(state.data, hash, defaultRequestState())
  }

  // Assign a new object so Vue can track the new properties
  state.data[hash] = {
    ...state.data[hash],
    ...newValues
  }
}

export default {
  [MUTATIONS.FETCHING]: (state, { hash }) => {
    updateState(state, hash, { isFetching: true })
  },

  [MUTATIONS.FAILED]: (state, { hash, error }) => {
    updateState(state, hash,
      { isFetching: false, hasFailed: true, hasFetched: true, error })
  },

  [MUTATIONS.SAVE]: (state, { hash, data }) => {
    if (Array.isArray(data)) {
      data.forEach(resource => {
        const resourceObject = defaultRequestState()

        resourceObject.data = resource
        resourceObject.hasFetched = true

        Vue.set(state.data, resource.id, resourceObject)
      })
    }

    updateState(state, hash, { data, isFetching: false, hasFetched: true })
  }
}
